import { isDate } from 'date-fns__legacy__';
import iconGrid3 from 'icon/win10/grid-3.svg?component'
import iconGrid2 from 'icon/win10/grid-2.svg?component'
import { getNegotiation, getNegotiationList, updateNegotiationStatus, getRequestRate, addRequesterRate, updateRequesterRate, getRequesterRateList, getSenderInfo} from 'Api/quoteNegotiationApi'
import { parseNegotiationList, parseNegotiationDetails, parseRequestRateUser, parseRequestRateList, parseRequestSenderInfo } from 'Parsers/negotiationParser'
import { cardViewTypes } from 'Enums/interfacePreferenceTypes'
import ChatDetailsModeMobile from 'Enums/ChatDetailsModeMobile'
import pascalToCamelCase from 'Services/pascalToCamelCase'
import negotiationSortTypes from 'Enums/negotiationSortTypes'
import negotiationFilterTypes from 'Enums/negotiationFilterTypes'
import negotiationActivityTypes from 'Enums/negotiationActivityTypes'
import { QuoteNegotiationState } from 'Types/QuoteNegotiation/App'
import { formatRequesterRateAdd, formatRequesterRateUpdate } from 'Formatters/quoteNegotiationFormatter'
import { parseReview } from 'Parsers/profileParser'
import formatDate from 'date-fns__legacy__/format'

const state: QuoteNegotiationState = {
  requesting: {
    negotiationList: false,
    details: false,
    status: false,
    rateList: false,
    rateUser: false,
    rateUpdate: false,
    infoSender: false
  },

  pagination: {
    current: 1,
    limit: 1,
  },
  paginationReview: {
    current: 1,
    limit: 1,
  },

  selected: {
    mode: cardViewTypes.list,
    sort: negotiationSortTypes.purchaseDate,
    statusFilter: [],
    dateFilter: '',
    activityFilter: [],
    serviceTypeFilter: [],
    mobileChatView: ChatDetailsModeMobile.chat
  },

  modeList: [
    { id: cardViewTypes.list, type: 'list', name: 'Em lista', icon: iconGrid3 },
    { id: cardViewTypes.grid, type: 'grid', name: 'Em grade', icon: iconGrid2 },
  ],

  searchTerm: [],

  negotiationList: [],

  negotiationDetails: null,

  mobileChatView: [
    { id: 1, type: 'chat' },
    { id: 2, type: 'details' },
  ],

  totalRate: 0,

  rateList: [],
  rateUser: {},
  senderInfo: {}
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_negotiation_list(state, negotiationList) {
    state.negotiationList = negotiationList
  },

  set_negotiation_details(state, negotiationDetails) {
    state.negotiationDetails = negotiationDetails
  },

  set_pagination(state, pagination) {
    Object.assign(state.pagination, pagination)
  },

  set_pagination_review(state, pagination) {
    Object.assign(state.paginationReview, pagination)
  },

  set_selected(state, selected) {
    Object.assign(state.selected, selected)
  },

  set_search_term(state, searchTerm) {
    state.searchTerm = searchTerm
  },

  add_request_status(state, id) {
    const statusList = state.requestingStatus.filter(item => item !== id)

    state.requestingStatus = [...statusList, id]
  },

  remove_request_status(state, id) {
    state.requestingStatus = state.requestingStatus.filter(item => item != id)
  },

  set_rate_user(state, rateList) {
    state.rateUser = rateList
  },

  reset_rate_user(state) {
    state.rateUser = null
  },

  set_rate_list(state, rateList) {
    state.rateList = rateList
  },

  set_sender_info(state, senderInfo) {
    state.senderInfo = senderInfo
  },

  set_total_rate(state, total) {
    state.totalRate = total
  },

  reset_rate_list(state) {
    state.rateList.length = 0
  },
}

const actions = {
  getSyncList({ commit }, syncData) {
    const data = pascalToCamelCase(syncData)
    const negotiationList = parseNegotiationList(data)
    commit('set_negotiation_list', negotiationList)

    const limit = data.pageCount
    commit('set_pagination', { limit })
  },

  async getList({ commit, state }, disableActivities) {
    commit('request_start', 'negotiationList')

    const { pagination, searchTerm, selected } = state

    try {
      const { data } = await getNegotiationList(
        pagination.current,
        {
          filter: searchTerm,
          status: selected.statusFilter,
          sort: Number(selected.sort),
          activities: disableActivities ?  null : selected.activityFilter,
          startDate: selected.dateFilter.startDate ? formatDate(new Date(selected.dateFilter.startDate), 'DD/MM/YYYY') : null,
          endDate: selected.dateFilter.endDate ? formatDate(new Date(selected.dateFilter.endDate), 'DD/MM/YYYY') : null,
          serviceType: selected.serviceTypeFilter

        })

      const negotiationList = parseNegotiationList(data)
      commit('set_negotiation_list', negotiationList)

      const limit = data.pageCount
      commit('set_pagination', { limit })

      commit('request_success', 'negotiationList')

      return negotiationList
    } catch (err) {
      commit('request_failure', 'negotiationList')

      throw err
    }
  },

  async searchRequest({ commit, dispatch }, searchTerm) {
    commit('set_search_term', searchTerm)
    commit('set_pagination', { current: 1 })

    const result = await dispatch('getList')

    return result
  },

  async getDetails({ commit }, negotiationId) {
    commit('request_start', 'details')

    try {
      const { data } = await getNegotiation(negotiationId)
      const negotiation = parseNegotiationDetails(data)
      commit('set_negotiation_details', negotiation)

      commit('request_success', 'details')

      return negotiation
    } catch (err) {
      commit('request_failure', 'details')

      throw err
    }
  },

  async updateStatus({ commit }, { negotiationId, status }) {
    commit('request_start', 'status')

    try {
      const result = await updateNegotiationStatus(negotiationId, status)
      commit('request_success', 'status')

      return result
    } catch (err) {
      commit('request_failure', 'status')

      throw err
    }
  },

  async changePage({ commit, dispatch }, current) {
    try {
      commit('set_pagination', { current })
      const result = await dispatch('getList')

      return result
    } catch (err) {
      throw err
    }
  },

  async changeFilter({ commit, dispatch }, filter: {name: string, value: []}) {
    commit('set_pagination', { current: 1, limit: 1 })
    commit('set_selected', { [filter.name]: filter.value });

    const result = await dispatch('getList')

    return result
  },

  updateSelected({ commit }, payload) {
    commit('set_selected', payload)
  },

  // #region Rate Requester

  resetRateUser({ commit }) {
    commit('reset_rate_user')
  },

  resetRateList({ commit }) {
    commit('reset_rate_list')
  },

  async getRate({ commit }, negotiationId) {
    commit('request_start', 'rateUser')
    try {
      const { data } = await getRequestRate(negotiationId)

      const rateUser = parseRequestRateUser(data)
      commit('set_rate_user', rateUser)
      commit('request_success', 'rateUser')

      return data
    } catch (err) {
      commit('request_failure', 'rateUser')

      throw err
    }
  },

  async getRateList({ commit }, userId) {
    const { paginationReview } = state
    const { rateList: currentRateList } = state
    commit('request_start', 'rateList')
    try {
      const params = {
        userId,
        page: paginationReview.current,
        pageSize: paginationReview.pageSize || 2
      }
      const { data } = await getRequesterRateList(params)
      const rateList = data.items.map(parseRequestRateList)
      const limit = data.pageCount
      const total = data.totalCount

      commit('set_pagination_review', { limit })
      commit('set_total_rate', total )

      commit('set_rate_list', [
        ...currentRateList,
        ...rateList
      ])

      commit('request_success', 'rateList')

      return data
    } catch (err) {
      commit('request_failure', 'rateList')

      throw err
    }
  },


  loadMoreRateList({ commit, dispatch, state }, userId) {
    const { paginationReview } = state

    const current = paginationReview.current + 1
    commit('set_pagination_review', { current })

    dispatch('getRateList', userId)
  },

  async addRate({ commit }, rate) {
    commit('request_start', 'rateUpdate')

    try {
      const formatedRate = formatRequesterRateAdd(rate)
      const result = await addRequesterRate(formatedRate)

      commit('request_success', 'rateUpdate')

      return result
    } catch (err) {
      commit('request_failure', 'rateUpdate')

      throw err
    }
  },

  async updateRate({ commit }, rate) {
    commit('request_start', 'rateUpdate')
    try {
      const formatedRate = formatRequesterRateUpdate(rate)
      const result = await updateRequesterRate(formatedRate)

      commit('request_success', 'rateUpdate')

      return result
    } catch (err) {
      commit('request_failure', 'rateUpdate')

      throw err
    }
  },

  async getSenderInfo({ commit }, idUser) {
    commit('request_start', 'infoSender')
    try {
      const { data } = await getSenderInfo(idUser)
      const formatedInfo = parseRequestSenderInfo(data)
      commit('set_sender_info', formatedInfo)

      commit('request_success', 'infoSender')

      return data
    } catch (err) {
      commit('request_failure', 'infoSender')

      throw err
    }
  },
  // #endregion
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}